import axios from 'axios'

export default {
  status: (context) => {
    // eslint-disable-next-line no-unused-vars
    const { commit } = context

    return new Promise((resolve, reject) => {
      axios.get('contact')
        .then(response => {
          const { data } = response

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  restart: (context) => {
    // eslint-disable-next-line no-unused-vars
    const { commit } = context

    return new Promise((resolve, reject) => {
      axios.post('contact')
        .then(response => {
          const { data } = response

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
